/**
 * Auth error codes matching backend AuthErrorCode type
 * and frontend-specific error codes
 */
export const AUTH_ERROR_CODES = {
    // Backend error codes (from backend/services/auth/src/types/index.ts)
    INVALID_TOKEN: "invalid_token",
    TOKEN_EXPIRED: "token_expired",
    TOKEN_REVOKED: "token_revoked",
    TOKEN_ROTATED: "token_rotated",
    USER_NOT_FOUND: "user_not_found",
    USER_INACTIVE: "user_inactive",
    TENANT_ACCESS_DENIED: "tenant_access_denied",
    PERMISSION_DENIED: "permission_denied",
    RATE_LIMITED: "rate_limited",
    INVALID_REQUEST: "invalid_request",
    INTERNAL_ERROR: "internal_error",
    // Frontend-specific codes
    NETWORK_ERROR: "network_error",
    EXCHANGE_FAILED: "exchange_failed",
    NOT_AUTHENTICATED: "not_authenticated",
    SESSION_EXPIRED: "session_expired",
    TOKEN_REFRESH_FAILED: "token_refresh_failed",
    UNKNOWN_ERROR: "unknown_error",
} as const;

export type AuthErrorCode =
    (typeof AUTH_ERROR_CODES)[keyof typeof AUTH_ERROR_CODES];

/**
 * Structured auth error with all information needed for display
 */
export interface AuthErrorInfo {
    /** Error code for programmatic handling */
    code: AuthErrorCode;
    /** Raw error message from backend or system */
    message: string;
    /** Unique reference ID for support tickets (format: ERR-YYYYMMDD-XXXXX) */
    referenceId: string;
    /** Timestamp when error occurred */
    timestamp: Date;
    /** Whether this error is retryable */
    isRetryable: boolean;
}
